var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightArrowTimeOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.875 4.00003C0.875 3.84774 0.935497 3.70169 1.04318 3.594C1.15087 3.48631 1.29692 3.42582 1.44922 3.42582H11.0884L9.48057 1.93286C9.42527 1.88158 9.38062 1.81991 9.34915 1.75138C9.31768 1.68284 9.30002 1.60878 9.29718 1.53342C9.29434 1.45806 9.30637 1.38288 9.33258 1.31217C9.35879 1.24146 9.39867 1.1766 9.44995 1.1213C9.55351 1.00962 9.69719 0.943652 9.84938 0.937908C9.92474 0.935065 9.99993 0.947092 10.0706 0.973304C10.1414 0.999515 10.2062 1.0394 10.2615 1.09067L12.9412 3.57894C12.9992 3.63269 13.0454 3.69784 13.077 3.7703C13.1087 3.84276 13.125 3.92097 13.125 4.00003C13.125 4.07909 13.1087 4.15731 13.077 4.22977C13.0454 4.30222 12.9992 4.36737 12.9412 4.42112L10.2615 6.90939C10.1498 7.01295 10.0016 7.0679 9.84938 7.06216C9.69719 7.05641 9.55351 6.99045 9.44995 6.87876C9.34639 6.76708 9.29144 6.61884 9.29718 6.46664C9.30292 6.31445 9.36889 6.17076 9.48057 6.06721L11.0884 4.57425H1.44922C1.29692 4.57425 1.15087 4.51375 1.04318 4.40606C0.935497 4.29838 0.875 4.15232 0.875 4.00003Z",
    fill: "#EA5B0C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowTimeOrange);
export default __webpack_public_path__ + "static/media/RightArrowTimeOrange.2ac5c5a6e87abdd6ede21b06d49291d6.svg";
export { ForwardRef as ReactComponent };